import { ReactElement, ReactNode } from 'react'
import { Box, IconButton, IconButtonProps, Tooltip, TooltipProps } from '@mui/material'

interface TooltipIconButtonProps extends IconButtonProps {
  tooltip?: string
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>
  children: ReactNode
  disabled?: boolean
  href?: string
  target?: string
  component?: 'a' | 'button'
}

const TooltipIconButton = ({
  tooltip,
  tooltipProps,
  children,
  disabled = false,
  ...iconButtonProps
}: TooltipIconButtonProps): ReactElement => {
  const button = (
    <IconButton disabled={disabled} {...iconButtonProps}>
      {children}
    </IconButton>
  )

  if (!tooltip) {
    return button
  }

  return (
    <Tooltip title={tooltip} arrow disableInteractive placement="bottom" {...tooltipProps}>
      {disabled ? (
        <Box component="span" sx={{ display: 'inline-flex' }}>
          {button}
        </Box>
      ) : (
        button
      )}
    </Tooltip>
  )
}

export default TooltipIconButton
